import React, { Suspense, lazy, useState } from "react";
import AuthUser from "./../front/Auth/AuthUser";
import UnAuthorize from "../front/components/Common/unAuthorizedUser";
import NotFound from "../front/components/Common/notFound";
const Home = lazy(() => import("./../front/pages/home"));
const Contact = lazy(() => import("./../front/pages/contact"));
const Login = lazy(() => import("./../front/Auth/Login"));
const Companies = lazy(
  () => import("./../front/components/Client/Companies/Companies")
);
const Vendors = lazy(
  () => import("./../front/components/Client/StoreVendor/Vendors")
);
const Runner = lazy(() => import("./../front/components/Client/Runner/Runner"));
const ExpenseType = lazy(
  () => import("./../front/components/Client/ExpenseTypes/ExpenseType")
);
const SalesRep = lazy(
  () => import("./../front/components/Client/SalesRep/SalesRep")
);
const Contractor = lazy(
  () => import("./../front/components/Client/Contractors/Contractor")
);
const User = lazy(() => import("./../front/components/Client/Users/User"));
const ResetPassword = lazy(
  () => import("./../front/components/Client/Users/ResetPassword")
);
const Customers = lazy(
  () => import("./../front/components/Client/Customers/Customers")
);
const AdminDashBoard = lazy(
  () => import("./../front/components/AdminDashBoard")
);
const Detail = lazy(
  () => import("./../front/components/Client/Customers/Detail")
);
const Contract = lazy(
  () => import("./../front/components/Client/Contracts/Contracts")
);
const ContractorBills = lazy(
  () => import("./../front/components/Client/ContractorBill/ContractorBills")
);
const SalesPersonCommission = lazy(
  () =>
    import(
      "./../front/components/Client/SalesPersonCommissions/SalesPersonCommission"
    )
);
const AccPayIndex = lazy(
  () => import("./../front/components/Client/AccountPayable/Index")
);
const SalesProfitReport = lazy(
  () => import("./../front/components/Client/Reports/SalesProfitReport")
);
const DashBoard = lazy(() => import("./../front/components/dashBoard"));
const AdminUsers = lazy(
  () => import("../front/components/Admin/AdminUsers/AdminUser")
);
const AdminNormalUser = lazy(
  () => import("./../front/components/Admin/Users/User")
);
const Clients = lazy(
  () => import("./../front/components/Admin/Clients/Clients")
);
const ChangePassword = lazy(
  () => import("./../front/components/Client/Users/ChangePassword")
);
const PaymentSchedules = lazy(
  () => import("./../front/components/Client/PaymentSchedule/PaymentSchedules")
);
const PaymentReceive = lazy(
  () => import("./../front/components/Client/PaymentReceive/PaymentReceive")
);
const CustomerPaymentReport = lazy(
  () => import("./../front/components/Client/Reports/CustomerPaymentReport")
);
const ErrorLogReport = lazy(
  () => import("./../front/components/Client/Reports/ErrorLogReport")
);
const MenuSection = lazy(
  () => import("./../front/components/Admin/MenuSection/MenuSection")
);
const MenuLink = lazy(
  () => import("./../front/components/Admin/MenuLink/MenuLink")
);
const IPSecuritySetting = lazy(
  () =>
    import("./../front/components/Admin/IPSecuritySettings/IPSecuritySetting")
);
const ServerError = lazy(() => import("./../front/Auth/ServerError"));
interface RouteObject {
  key: number;
  element?: React.ReactNode;
  path?: string;
  Roles: Array<string>;
  userType?: number;
}

export const routeConfig: RouteObject[] = [
  {
    key: 1,
    element: <DashBoard />,
    path: "/Dashboard",
    Roles: ["Admin", "Project Manager", "Job Supervisor"],
  },
  {
    key: 2,
    element: <Companies />,
    path: "/Companies",
    Roles: ["Admin"],
  },
  {
    key: 3,
    element: <Vendors />,
    path: "/Vendors",
    Roles: ["Admin"],
  },
  {
    key: 4,
    element: <Runner />,
    path: "/Runners",
    Roles: ["Admin"],
  },
  {
    key: 5,
    element: <ExpenseType />,
    path: "/ExpenseTypes",
    Roles: ["Admin"],
  },
  {
    key: 6,
    element: <SalesRep />,
    path: "/SalesRep",
    Roles: ["Admin"],
  },
  {
    key: 7,
    element: <Contractor />,
    path: "/Contractor",
    Roles: ["Admin"],
  },
  {
    key: 8,
    element: <User />,
    path: "/User",
    Roles: ["Admin"],
  },
  {
    key: 10,
    element: <Customers />,
    path: "/Customers",
    Roles: ["Admin", "Project Manager"],
  },
  {
    key: 11,
    element: <Detail />,
    path: "/Customers/Detail/:customerId",
    Roles: ["Admin", "Project Manager"],
  },
  {
    key: 12,
    element: <ContractorBills />,
    path: "/ContractorBill",
    Roles: ["Admin", "Project Manager"],
  },
  {
    key: 13,
    element: <SalesPersonCommission />,
    path: "/SalesPersonCommission",
    Roles: ["Admin"],
  },
  {
    key: 15,
    element: <AccPayIndex />,
    path: "/AccountPayable",
    Roles: ["Admin", "Project Manager"],
  },
  {
    key: 16,
    element: <SalesProfitReport />,
    path: "/SalesProfitReport",
    Roles: ["Admin", "Project Manager"],
  },
  {
    key: 17,
    element: <AdminUsers />,
    path: "/Admin/AdminUser",
    Roles: ["Master Admin"],
  },
  {
    key: 18,
    element: <AdminNormalUser />,
    path: "/Admin/User",
    Roles: ["Master Admin"],
  },
  {
    key: 19,
    element: <AdminDashBoard />,
    path: "/Admin/Dashboard",
    Roles: ["Master Admin"],
  },
  {
    key: 20,
    element: <Clients />,
    path: "/Admin/Clients",
    Roles: ["Master Admin"],
    userType: 1,
  },
  {
    key: 21,
    element: <Contract />,
    path: "/Contract",
    Roles: ["Admin"],
  },
  {
    key: 22,
    element: <ChangePassword />,
    path: "/ChangePassword",
    Roles: ["Admin", "Master Admin", "Project Manager", "Job Supervisor"],
  },
  {
    key: 23,
    element: <PaymentSchedules />,
    path: "/PaymentSchedules",
    Roles: ["Admin", "Project Manager"],
  },
  {
    key: 24,
    element: <PaymentReceive />,
    path: "/PaymentReceive",
    Roles: ["Admin", "Project Manager"],
  },
  {
    key: 24,
    element: <CustomerPaymentReport />,
    path: "/Report/CustomerPaymentReport",
    Roles: ["Admin", "Project Manager"],
  },
  {
    key: 25,
    element: <ServerError />,
    path: "/ServerError/:errorMessage",
    Roles: ["Admin", "Project Manager", "Master Admin"],
  },
  {
    key: 26,
    element: <ErrorLogReport />,
    path: "/Admin/ErrorLogReport",
    Roles: ["Master Admin"],
  },
  {
    key: 27,
    element: <MenuSection />,
    path: "/Admin/MenuSection",
    Roles: ["Master Admin"],
  },
  {
    key: 27,
    element: <MenuLink />,
    path: "/Admin/MenuLink",
    Roles: ["Master Admin"],
  },
  {
    key: 27,
    element: <IPSecuritySetting />,
    path: "/Admin/IPSecuritySetting",
    Roles: ["Master Admin"],
  },
  {
    key: 28,
    element: <Detail />,
    path: "/Customers/Detail",
    Roles: ["Admin", "Project Manager"],
  },
];

export default routeConfig;
